import React from 'react';
import { Users, MessageCircle, Heart } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      icon: <Users className="w-8 h-8" />,
      title: 'Choose Your Deity',
      description: 'Krishna, Saraswati, Shiva and more.',
      color: 'from-orange-500 to-amber-500'
    },
    {
      number: '02',
      icon: <MessageCircle className="w-8 h-8" />,
      title: 'Talk and Seek Guidance',
      description: 'Chat or voice conversations anytime.',
      color: 'from-amber-500 to-yellow-500'
    },
    {
      number: '03',
      icon: <Heart className="w-8 h-8" />,
      title: 'Build Your Spiritual Practice',
      description: 'Receive daily wisdom and guidance.',
      color: 'from-yellow-500 to-orange-500'
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4 text-white">
            How It Works
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Three simple steps to begin your spiritual journey
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center group relative">
              <div className="relative mb-8">
                {/* Step Number */}
                <div className="text-8xl font-bold text-white/10 mb-4">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className={`w-20 h-20 mx-auto bg-gradient-to-r ${step.color} rounded-2xl flex items-center justify-center text-white shadow-2xl group-hover:shadow-3xl transition-all duration-300 hover:scale-110`}>
                  {step.icon}
                </div>
              </div>
              
              <h3 className="font-serif text-2xl font-bold mb-4 text-white">
                {step.title}
              </h3>
              <p className="text-gray-300 text-lg">
                {step.description}
              </p>
              
              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-32 left-full w-8 h-0.5 bg-gradient-to-r from-orange-500/50 to-transparent transform translate-x-4"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;